<template>
    <div class="freetargetImage-box topHostImage"><img :src='TopHostsImage' alt="" /></div>    
</template>
<script>
import TopHostsImage from '../../assets/images/tophoast/topHost_banner.webp'
export default {
    name: 'TopHosts',
    data() {
        return {
            TopHostsImage: TopHostsImage,
        }
    },
}
</script>
<!-- <style>
.topHostImage {
    overflow: hidden;
    object-fit: cover;
    max-height: 100vh;
}
</style> -->